import PropTypes from "prop-types";
import "./CheckBox.css";
import { useEffect, useRef } from "react";

function CheckBox(props) {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = props.indeterminate;
    }
  }, [props.indeterminate]);

  return (
    <div
      className="user-select-none font-size-small display-flex flex-align-items-center cursor-pointer"
      data-cy={props["data-cy"] ? props["data-cy"] : "checkbox"}
    >
      <input
        ref={checkboxRef}
        id={props.name}
        type="checkbox"
        name={props.name}
        onChange={props.onChange}
        checked={props.checked}
        data-cy={props.name}
        className="display-none cursor-pointer"
        disabled={props.disabled}
      />

      <label
        data-cy="CUSTOM-CHECKBOX"
        htmlFor={props.name}
        className={`
          ${props.className || ""}
          position-relative background-white check-box-size cursor-pointer check-mark
          ${props.indeterminate ? "checkbox-indeterminate" : ""}
        `}
      />

      {props.label && (
        <label
          htmlFor={props.name}
          className={`
            ${props.labelClassName || ""}
            display-block position-relative cursor-pointer
            font-size-small user-select-none padding-left-default
          `}
        >
          {props.label}
        </label>
      )}
    </div>
  );
}

CheckBox.propTypes = {
  /**
   * label which you want to give
   */
  label: PropTypes.any.isRequired,
  /**
   * cypress selector attribute for testing
   */
  "data-cy": PropTypes.string,
  /**
   * Checkbox input name attribute, default name is `name='checkbox'`
   */
  name: PropTypes.string,
  /**
   * onChange function prop `onChange={(event)=>{}}`
   */
  onChange: PropTypes.func
};

CheckBox.defaultProps = {
  label: "",
  "data-cy": "checkbox",
  name: "checkbox",
  onChange: undefined
};

export default CheckBox;
